
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import { Group } from '../../backend/backendapi';
import ExternalUsersEditor from './ExternalUsersEditor';
import { GroupSelector } from '../util';

@Component({
  components: {
    ExternalUsersEditor,
  },
})
export default class TabUsersExternal<T> extends Vue {
  @Prop({ required: true })
  group!: Group;
  @Prop({ default: '' })
  readonly groupSelector!: GroupSelector<T>;
  @Prop({ required: true })
  readonly availableSalutations!: string[];
  @Prop({ default: false })
  readonly hideDisabled!: boolean;
  @Prop({ default: false })
  readonly hideMassSelection!: boolean;
  @Prop({ default: false })
  readonly allowNoEmailForExternalUsers!: boolean;
}
